module.exports = __webpack_public_path__ + "static/media/galerija_2019 (29).45b06e87.jpg";